import React from 'react';

import {
  Card,
  Button,
  Row,
  Col,
  Table,
} from 'antd';

import {
  _getThreePs,
  _putThreeP,
  _deleteThreeP,
} from "../../services";

import {
  createDataTree
} from "./functions";

import ThreePInput from "./input";
import ActionButtons from "./actions-buttons";

class ThreePsEditor extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      threePData: [],
      treeData: [],

      activeLevel1: false,
      activeLevel2: false
    };
  }

  render() {
    return (
      <div>
        <div>
          {this.renderTable()}
        </div>

        <Row gutter={[8, 8]}>

          {/* LEVEL 1 */}
          <Col span={6}>
            <Card>
              <Row gutter={[16, 4]}>
                <Col span={24}>L1</Col>
                <Col span={24}>{this.renderInput(1)}</Col>
                {this.renderList(1, null)}
              </Row>
            </Card>
          </Col>

          {/* LEVEL 2 */}
          <Col span={8}>
            <Card>
              <Row gutter={[16, 4]}>
                <Col span={24}>L2</Col>
                <Col span={24}>{this.renderInput(2, this.state.activeLevel1)}</Col>
                {this.renderList(2, this.state.activeLevel1)}
              </Row>
            </Card>

          </Col>

          {/* LEVEL 3 */}
          <Col span={10}>
            <Card>
              <Row gutter={[16, 4]}>
                <Col span={24}>L3</Col>
                <Col span={24}>{this.renderInput(3, this.state.activeLevel2)}</Col>
                {this.renderList(3, this.state.activeLevel2)}
              </Row>
            </Card>

          </Col>

        </Row>

      </div>
    );
  }

  /* DATA */
  async componentDidMount() {
    this.getData();
  }

  getData = async () => {

    const threePsXhr = await _getThreePs();
    const threePs = threePsXhr.data;

    /* Reshape into tree data */
    const treeData = createDataTree(threePs)

    this.setState({
      threePData: threePs,
      treeData
    });

  };

  filterData = (level, parentId) => {

    let data = this.state.threePData
      .filter(_d => _d.level === level);

    /* 
     * If parentId is provided, filter to only those with parentId
     * else show all options    
     **/
    if (parentId) {
      data = data.filter(_d => _d.parentId === parentId);
    }

    return data;

  };

  /* RENDER  */
  renderInput = (level, parentId) => {
    return (
      <ThreePInput
        level={level}
        parentId={parentId}
        getData={this.getData} />
    );
  };

  renderList = (level, parentId) => {

    const data = this.filterData(level, parentId);

    return (
      data.map(_d => (
        <Col span={24}>

          <Row gutter={8}>
            <Col span={20} style={{ display: 'flex' }}>
              {level === 3 ?
                <div style={{
                  borderRadius: '5px',
                  border: '1px solid rgb(217, 217, 217)',
                  padding: '5px 10px',
                }}>
                  {_d.title}
                </div>
                :
                <Button
                  type={this.state[`activeLevel${level}`] === _d._id ? 'primary' : null}
                  onClick={() => this.onListButtonClick(_d.level, _d._id)}>
                  {_d.title}</Button>
              }
            </Col>

            <Col span={4}>
              <ActionButtons
                data={_d}
                onListButtonDelete={this.onListButtonDelete}
                onListButtonEdit={this.onListButtonEdit} />
            </Col>

          </Row>
        </Col>
      ))
    );
  };

  renderTable = () => {
    const columns = [
      {
        title: 'Data',
        dataIndex: 'title',
        key: 'title',
      },
    ];

    return (
      <Card>
        <Table
          columns={columns}
          dataSource={this.state.treeData}
          pagination={false}
        />
      </Card>
    );
  }


  onListButtonClick = (level, id) => {

    /* if current active == id then it is a deactive */
    if (this.state[`activeLevel${level}`] === id) {
      this.setState({
        [`activeLevel${level}`]: false
      });

      return;
    }

    /* Else it is an activate */
    this.setState({
      [`activeLevel${level}`]: id
    });
    /* If it is a level 1 activate, deactivate existing level 2 as well */
    if (level === 1) {
      this.setState({
        activeLevel2: false
      });
    }

  };

  onListButtonDelete = async (id) => {

    await _deleteThreeP({ id });

    this.getData();

  };

  onListButtonEdit = async (id, value) => {

    await _putThreeP({ id, value });

    this.getData();

  };

}

export default ThreePsEditor;


// WEBPACK FOOTER //
// ./src/components/three-ps/editor.js